import { displayError, displayWarning } from "../../utils/messageToast";
import { SetupFlow } from "../../apis/apisFlowByAuthorizationRA";
import { getFormSideProps } from "../getFormSideProps";
import { displaySuccess } from "../../utils/messageToast";
import { FieldProps, GroupProps } from "../../utils/functionsInterfaces";

export const publishForm = async (
  setExpandedPages: React.Dispatch<React.SetStateAction<boolean>>,
  setShowTopPageContainer: React.Dispatch<React.SetStateAction<boolean>>,
  setNamePage: React.Dispatch<React.SetStateAction<string>>,
  setPageId: React.Dispatch<React.SetStateAction<string>>,
  setIsData: React.Dispatch<React.SetStateAction<boolean>>,
  setLoadingButtonPublish: React.Dispatch<React.SetStateAction<boolean>>,
  idFormSaved: string,
  setSearch: React.Dispatch<React.SetStateAction<string>>,
  setFormId: React.Dispatch<React.SetStateAction<string>>,
  setNameForm: React.Dispatch<React.SetStateAction<string>>,
  setSkillIdForm: React.Dispatch<React.SetStateAction<string>>,
  setTabIdForm: React.Dispatch<React.SetStateAction<string>>,
  setItemId: React.Dispatch<React.SetStateAction<string>>,
  setGroups: React.Dispatch<React.SetStateAction<GroupProps[]>>,
  setFields: React.Dispatch<React.SetStateAction<FieldProps[]>>,
  setShowTopContainer: React.Dispatch<React.SetStateAction<boolean>>,
  setButtonSave: React.Dispatch<React.SetStateAction<boolean>>,
  setButtonPublish: React.Dispatch<React.SetStateAction<boolean>>,
  clientId: string,
  authorizationRA: string,
  aliasFormResult: string,
  setAliasFormResult: React.Dispatch<React.SetStateAction<string>>,
  setForm: React.Dispatch<React.SetStateAction<any>>,
  checkTheFunction: boolean,
  ambient: string,
  setTabName: React.Dispatch<React.SetStateAction<string>>,
  setSkillName: React.Dispatch<React.SetStateAction<string>>,
  authorization: string,
  signOut: () => void
) => {
  try {
    setLoadingButtonPublish(true);
    if (idFormSaved === "") {
      displayWarning("Salve o formulário antes de publicar!");
      return;
    }
    const apiClient = SetupFlow(authorizationRA);
    await apiClient.post(
      `/publish-form?formId=${idFormSaved}&ambient=${ambient}`
    );
    displaySuccess("Formulário publicado!");
    setButtonSave(true);
    setButtonPublish(false);
    setSearch(aliasFormResult);
    setLoadingButtonPublish(false);

    if (checkTheFunction) {
      await getFormSideProps(
        setExpandedPages,
        setShowTopPageContainer,
        setNamePage,
        setPageId,
        setIsData,
        aliasFormResult,
        setFormId,
        setNameForm,
        setSkillIdForm,
        setTabIdForm,
        setItemId,
        setGroups,
        setFields,
        setShowTopContainer,
        setButtonPublish,
        clientId,
        setAliasFormResult,
        setForm,
        ambient,
        setSkillName,
        authorization,
        setTabName,
        signOut
      );
    }
  } catch (error: any) {
    displayError("Erro ao publicar o formulário!");
    return;
  }
};
